<template>
	<Skeleton :loading="loading">
		<template #loading>
			<div class="gallery">
				<h4 class="text-heading2--bold ma--0 pa--4">{{ $t('pageRestaurant.text1') }}</h4>
				<el-row>
					<el-col :span="12" class="image-container-left">
						<div class="r-gallery color-gray95" />
					</el-col>
					<el-col :span="12" class="image-container-right">
						<div class="r-gallery color-gray95" />
					</el-col>
					<el-col :span="8" class="image-container-left">
						<div class="r-gallery color-gray95" />
					</el-col>
					<el-col :span="8" class="image-container">
						<div class="r-gallery color-gray95" />
					</el-col>
					<el-col :span="8" class="image-container-right">
						<div class="r-gallery color-gray95" />
					</el-col>
				</el-row>
			</div>
		</template>
		
		<template>
			<div class="gallery">
				<h4 class="text-heading2--bold ma--0 pa--4">{{ $t('pageRestaurant.text1') }}</h4>
				<div>
					<el-row>
						<template v-for="(url,index) in five_urls">
							<el-col v-if="index==0" :span="12" class="relative r-col-border-2-l" :key="'urlimg'+index">
								<div class="r-gallery">
									<el-image :src="url" :fit="'cover'" :preview-src-list="urls"></el-image>
								</div>
							</el-col>
							<el-col v-if="index==1" :span="12" class="relative r-col-border-2-r" :key="'urlimg'+index">
								<div class="r-gallery">
									<el-image :src="url" :fit="'cover'" :preview-src-list="urls"></el-image>
								</div>
							</el-col>
							<el-col v-if="index==2" :span="8" class="relative r-col-border-3-l" :key="'urlimg'+index">
								<div class="r-gallery">
									<el-image :src="url" :fit="'cover'" :preview-src-list="urls"></el-image>
								</div>
							</el-col>
							<el-col v-if="index==3" :span="8" class="relative r-col-border-3-c" :key="'urlimg'+index">
								<div class="r-gallery">
										<el-image :src="url" :fit="'cover'" :preview-src-list="urls"></el-image>
								</div>
							</el-col>
							<el-col v-if="index==4" :span="8" class="relative r-col-border-3-r" :key="'urlimg'+index">
								<div class="r-gallery">
										<el-image :src="url" :fit="'cover'" id="img_more" :preview-src-list="urls"></el-image>
								</div>
								<div class="r-gallery-view-more" @click="viewMoreImgae"><span>+{{urls.length}}</span></div>
							</el-col>
						</template>
					</el-row>
				</div>
			</div>
		</template>
	</Skeleton>
</template>

<script>
export default {
	props:{
		restaurantImage: { default: null },
		loading: { default: false }
	},
	methods: {
		viewMoreImgae() {
			this.$emit("toggle_all_image")
		}
	},
	computed: {
		urls() {
			return this.restaurantImage.map(item => {
				return 'https://images.foodstory.co/'+item.restaurant_image_key
			})
		},
		five_urls() {
			return this.urls.slice(0, 5)
		}
	}
}
</script>

<style lang="scss" scoped>
.image-container {
	padding: 2px;
	&-left {
		padding: 2px 2px 2px 0px;
	}
	&-right {
		padding: 2px 0px 2px 2px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/restaurant/RestaurantImage.vue